import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { question } from '@/dex-shared/helpers/normalizr_schema';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  async PULL_QUESTION_BY_ID({ commit }: any, questionId: number) {
    const response = await query(
      `query  PullQuestion($questionId: Int!) {
        questionById(id: $questionId) {
          id
          content
          answer
          source
          mode
          alternatives
          interactiveData
          group
          tags
          examModeId

          contentsByQuestionId {
            nodes {
              id
              position
              questionId
              textByTextId {
                id
                body
                alignment
                source
              }
              imageByImageId {
                id
                url
                source
                resizeFactor
                description
              }
              videoByVideoId {
                id
                providerId
                providerType
              }
            }
          }

          assertionsByQuestionId {
            nodes {
              id
              questionId
              position
              correct
              contentsByAssertionId {
                nodes {
                  id
                  position
                  assertionId
                  textByTextId {
                    id
                    body
                    alignment
                    source
                  }
                  imageByImageId {
                    id
                    url
                    source
                    resizeFactor
                    description
                  }
                  videoByVideoId {
                    id
                    providerId
                    providerType
                  }
                }
              }
            }
          }

          repliesByAlternative {
            nodes {
              answer
              total
            }
          }

          knowledgeAssociationsByQuestionId {
            nodes {
              formative
              summative
              knowledgeByKnowledgeId {
                id
                name
              }
            }
          }

          solutionsByQuestionId(orderBy: CREATED_AT_ASC){
            nodes {
              id
              content
              createdAt
              reportsBySolutionId {
                nodes {
                  id
                  kind
                  description
                  done
                  createdAt
                }
              }
              userByUserId{
                id
                name
              }
            }
          }

          userByUserId {
            id
            name
          }

          examQuestionsByQuestionId{
            totalCount
            nodes {
              examByExamId {
                id
                name
              }
            }
          }

          listItemsByQuestionId{
            totalCount
            nodes {
              listByListId {
                id
                name
              }
            }
          }

          questionApplicationsByQuestionId {
            nodes {
              id
              questionId
              examApplicationByExamApplicationId {
                id
                examTitle
                professionalTitle
                applicationYear
              }
            }
          }

          reportsByQuestionId {
            totalCount 
            nodes {
              id
              kind
              description
              done
              createdAt
            }
          }
        }
      }`,
      {
        questionId: +questionId,
      },
    );
    if (response.data.questionById) {
      const normalizedResponse = normalize(
        response.data.questionById,
        question,
      );
      commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    } else {
      return 404;
    }
  },

  async PUSH_QUESTION_BY_ID({ dispatch, getters }: any, questionId: number) {
    let question = getters.questionById(questionId);

    await Promise.all([
      dispatch('UPDATE_CONTENTS', question.contents()),
      dispatch('UPDATE_ASSERTIONS', question.assertions()),
      mutation(
        `mutation updateQuestion ($id: Int!, $title: String,
            $content: JSON!, $examModeId: Int, $tags: String,
            $answer: JSON, $source: JSON, $mode: String,
            $alternatives: Int, $interactiveData: JSON,
            $group: String, $examApplicationId: Int) {
          updateQuestionById(
            input: {
              id: $id,
              questionPatch:{
                draft: false
                title: $title
                content: $content,
                examModeId: $examModeId,
                answer: $answer,
                source: $source,
                mode: $mode,
                alternatives: $alternatives,
                interactiveData: $interactiveData,
                group: $group
                tags: $tags
                examApplicationId: $examApplicationId
              }
            }
          ){
            question {
              id
              draft
              title
              content
              examModeId
              answer
              source
              mode
              alternatives
              interactiveData
              group
              examApplicationId
            }
          }
        }`,
        question.raw(),
      ),
    ]);
  },

  async CREATE_QUESTION({ commit, rootState, dispatch }) {
    const userId = rootState.auth.user.id;
    const response = await mutation(
      `mutation CreateQuestion ($userId: Int!) {
        createQuestion(input: {
          question: {
            userId: $userId
            draft: true
          }
        }) {
          question {
            id
          }
        }
      }`,
      {
        userId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'questions',
      data: response.data.createQuestion.question,
    });
    const questionId = response.data.createQuestion.question.id;
    await Promise.all(
      [...Array(5).keys()].map((position: number) =>
        dispatch('CREATE_ASSERTION', { questionId, position }),
      ),
    );
    return questionId;
  },
};
